<template>
    <div class="pb-2">
        <label :id="id + '-dropdown-label'" class="text-dark w-100 fw-bold">{{title}}:
            <b-link href class="ms-1" v-if="showHelp" @click="setContentType(id); showModal()"><i class="fas fa-question-circle fa-sm"></i><span class="sr-only">help</span></b-link>
        </label>

        <div>
            <BFormSelect  v-model="selected" :options="data" @change="updateFilterValues" class="custom-select">
                <template #first>
                    <BFormSelectOption  :value="null">{{defaultDisplayTitle}}</BFormSelectOption >
                </template>
            </BFormSelect>
        </div>

    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import bus from '@/shared/event-bus.js';

export default {
    name: 'Select',
    props: {
        title: {
            required: true
        },
        id: {
            required: true
        },
        data: {
            required: false
        },
        showHelp: {
            required: false
        }
    },
    computed: {
        ...mapGetters([
            'selectedFilters'
        ]),
        defaultDisplayTitle: function () {
            switch (this.id) {
                case 'fundingmechanism':
                    return 'All Mechanisms';
                case 'year':
                    return 'All Years';
                case 'topic':
                    return 'All Topics';
                case 'ic':
                    return 'All Institute/Centers';
                case 'activity':
                    return 'All Activities';
                case 'variable':
                    return 'All Variables';
                case 'portfolio':
                    return 'All Portfolios';
            }
        }
    },
    data: function () {
        return {
            selected: null
        };
    },
    watch: {
        '$store.state.selectedFilters': function (val) {
            if (_.isEmpty(val)) {
                this.selected = null;
            }
        }
    },
    mounted () {

    },
    methods: {
        ...mapActions([
            'setSelectedFilter',
            'setContentType'
        ]),
        updateFilterValues () {
            this.setSelectedFilter({type: this.id, data: this.selected});
        },
        showModal () {
            bus.$emit('help:show');
        }
    }
};
</script>

<style lang="scss" scoped>

</style>